import router from '@/router'

export const TableModel = (api) => {
  return {
    extend ({ state = {}, getters = {}, mutations = {}, actions = {}, namespaced } = {}) {
      return {
        namespaced,
        state () {
          return {
            items: [],
            pagination: null,
            ...state
          }
        },
        getters: {
          total (state) {
            if (state.pagination === null) {
              return null
            }

            return state.pagination.last_page
          },

          max (state, getters) {
            if (state.pagination === null) {
              return null
            }

            return Math.min(getters.total - 1, 9)
          },

          page (state) {
            if (state.pagination === null) {
              return null
            }

            return state.pagination.current_page
          },

          ...getters
        },
        mutations: {
          setItems (state, items) {
            state.items = items
          },

          setPagination (state, pagination) {
            state.pagination = pagination
          },

          ...mutations
        },
        actions: {
          setItems (context, items) {
            context.commit('setItems', items)
          },

          setPagination (context, pagination) {
            context.commit('setPagination', pagination)
          },

          async nextPage (context, page) {
            const { authUserCompany } = context.rootGetters

            try {
              const response = await api.getAll(authUserCompany.slug, router.currentRoute.params.slug, page)
              context.commit('setItems', response ? response.data : [])
              context.commit('setPagination', response ? response.meta : null)
            } catch (e) {
              console.error(e)
            }
          },

          async fetchItems (context, slug) {
            const { authUserCompany } = context.rootGetters
            const { data, meta } = await api.getAll(authUserCompany.slug, slug)
            context.commit('setItems', data)
            context.commit('setPagination', meta)
          },

          ...actions
        }
      }
    }
  }
}
